import axios from 'axios'
import { NIA_LOGIN_URL, NIA_STATE_URL } from './settings'

export interface iNiaState {
  stav: string,
  stavID: number,
}
// TODO interface + error interface
class NiaApi {
  api = axios.create({
    baseURL: NIA_STATE_URL,
  })

  loginRedirectUrl = (extId: string, target: string, osobaId = '0') =>
    `${NIA_LOGIN_URL}/login/${extId}/osoba/${osobaId}?redirect=true&target=${encodeURIComponent(target)}`

  getToken = (extId: string) =>
    this.api.get(`/token/${extId}`)
      .then(res => res.data)

  getStatus = (extId: string) =>
    this.api.get<iNiaState>(`/stav/${extId}`)
      .then(res => res.data)

  getRefresh = (extId: string) =>
    this.api.get(`/refresh/${extId}`)
  // TODO + bearer token - bearerAuth: ${token}

  getLogout = () =>
    this.api.get(`/logout`)
  // TODO + bearer token - bearerAuth: ${token}

}

export default new NiaApi()
